import ActionTypes from "../../../../constants/ActionTypes";
import {
  ICheckCssStatusRequestAction, IClearDeliveryAddressAction, IProcessCampaignSubmitAction,
  IRequestFetchCampaignOverviewDataAction,
  ISendAcceptanceRequestAction, ISetAcceptanceRequestEmailStatusAction,
  ISetAcceptanceRequestSmsStatusAction,
  ISetAcceptanceStatusAction,
  ISetCampaignOverviewDataAction,
  ISetConsentsFromResponseAction, ISetContactEmailAction,
  ISetCosmosConsentAction, ISetDeliveryAddressAction, ISetDeliveryOptionAction, ISetEmailWasValidatedAction, ISetESIMCardAction,
  ISetGlobalConsentAction,
  ISetInitialCampaignConsentAction,
  ISetIsActiveContactForMsisdnAction,
  ISetOverviewCmUserAction, ISetOverviewOfferAdditionalData,
  ISetOverviewOptionNameAction,
  ISetOverviewSoftOfferPackageAction,
  ISetOverviewTermsAction, ISetSelectedStoreIdAction,
  ISetSocialNetworkMatchingConsentAction,
  ISetSocialNetworksOfferingConsentAction, ISetUserTermsStatusAction, ISubmitCampaignAction,
} from "./types";
import { ISoftOfferPackage } from "../../../../entities/campaigns/types";
import { IPakValues } from "../../../../views/components/forms/pak/types";

export function requestFetchCampaignOverviewDataAction(params: object): IRequestFetchCampaignOverviewDataAction {
  return {
    type: ActionTypes.CAMPAIGN.FETCH,
    params,
  };
}

export function sendAcceptanceRequestAction(params: object): ISendAcceptanceRequestAction {
  return {
    type: ActionTypes.CAMPAIGN.ACCEPTANCE.SEND_REQUEST,
    params,
  };
}

export function checkCssStatusRequestAction(params: object): ICheckCssStatusRequestAction {
  return {
    type: ActionTypes.CAMPAIGN.OVERVIEW.CHECK_CSS_STATUS,
    params,
  };
}

export function setCampaignOverviewDataAction(campaignOverviewData: any): ISetCampaignOverviewDataAction {
  return {
    type: ActionTypes.CAMPAIGN.OVERVIEW.CREATE,
    payload: campaignOverviewData,
  };
}

export function setOverviewOfferAdditionalData(
  offerId: number,
  optionId: number,
  cnlId: number,
  contractDuration: number,
  p2p: number,
  p2pDj: number,
  upsell: number,
  stopNonResident?: number,
): ISetOverviewOfferAdditionalData {
  return {
    type: ActionTypes.CAMPAIGN.OVERVIEW.SET_OFFER_ADDITIONAL_DATA,
    payload: {
      offerId,
      optionId,
      cnlId,
      contractDuration,
      p2p,
      p2pDj,
      upsell,
      stopNonResident
    },
  };
}

export function setOverviewSoftOfferPackageAction(softOfferPackage: ISoftOfferPackage): ISetOverviewSoftOfferPackageAction {
  return {
    type: ActionTypes.CAMPAIGN.OVERVIEW.SET_SOFT_OFFER_PACKAGE,
    payload: softOfferPackage,
  };
}

export function setOverviewOptionNameAction(optionName: string): ISetOverviewOptionNameAction {
  return {
    type: ActionTypes.CAMPAIGN.OVERVIEW.SET_OPTION_NAME,
    payload: optionName,
  };
}

export function setOverviewTermsAction(terms: string): ISetOverviewTermsAction {
  return {
    type: ActionTypes.CAMPAIGN.OVERVIEW.SET_TERMS,
    payload: terms,
  };
}

export function setOverviewIsActiveContactForMsisdnAction(isActiveContactForMsisdnAction: boolean): ISetIsActiveContactForMsisdnAction {
  return {
    type: ActionTypes.CAMPAIGN.OVERVIEW.SET_IS_ACTIVE_CONTACT_FOR_MSISDN,
    payload: isActiveContactForMsisdnAction,
  };
}

export function setOverviewCmUserAction(cmUser: object): ISetOverviewCmUserAction {
  return {
    type: ActionTypes.CAMPAIGN.OVERVIEW.SET_CM_USER,
    payload: cmUser,
  };
}

export function setInitialCampaignConsentAction(givenConsents: object): ISetInitialCampaignConsentAction {
  return {
    type: ActionTypes.CAMPAIGN.CONSENT.CREATE,
    payload: givenConsents,
  };
}

export function setConsentsFromResponseAction(givenConsents: object): ISetConsentsFromResponseAction {
  return {
    type: ActionTypes.CAMPAIGN.CONSENT.SET_FROM_RESPONSE,
    payload: givenConsents,
  };
}

export function setGlobalConsentAction(status: number): ISetGlobalConsentAction {
  return {
    type: ActionTypes.CAMPAIGN.CONSENT.SET_GLOBAL_CONSENT,
    payload: status,
  };
}

export function setCosmosConsentAction(status: number): ISetCosmosConsentAction {
  return {
    type: ActionTypes.CAMPAIGN.CONSENT.SET_COSMOS_CONSENT,
    payload: status,
  };
}

export function setSocialNetworksOfferingConsentAction(status: number): ISetSocialNetworksOfferingConsentAction {
  return {
    type: ActionTypes.CAMPAIGN.CONSENT.SET_SOCIAL_NETWORKS_OFFERING_CONSENT,
    payload: status,
  };
}

export function setSocialNetworkMatchingConsentAction(status: number): ISetSocialNetworkMatchingConsentAction {
  return {
    type: ActionTypes.CAMPAIGN.CONSENT.SET_SOCIAL_NETWORKS_MATCHING_CONSENT,
    payload: status,
  };
}

export function setAcceptanceStatusAction(status: number): ISetAcceptanceStatusAction {
  return {
    type: ActionTypes.CAMPAIGN.ACCEPTANCE.SET_ACCEPTANCE_STATUS,
    payload: status,
  };
}

export function setAcceptanceRequestSmsStatusAction(status: boolean): ISetAcceptanceRequestSmsStatusAction {
  return {
    type: ActionTypes.CAMPAIGN.ACCEPTANCE.SET_ACCEPTANCE_REQUEST_SMS_STATUS,
    payload: status,
  };
}

export function setAcceptanceRequestEmailStatusAction(status: boolean): ISetAcceptanceRequestEmailStatusAction {
  return {
    type: ActionTypes.CAMPAIGN.ACCEPTANCE.SET_ACCEPTANCE_REQUEST_EMAIL_STATUS,
    payload: status,
  };
}

export function setUserTermsStatusAction(userTermsStatus: boolean): ISetUserTermsStatusAction {
  return {
    type: ActionTypes.CAMPAIGN.OVERVIEW.SET_USER_TERMS_STATUS,
    payload: userTermsStatus,
  };
}

export function setContactEmailAction(email: string): ISetContactEmailAction {
  return {
    type: ActionTypes.CAMPAIGN.OVERVIEW.SET_CONTACT_EMAIL,
    payload: email,
  };
}

export function setESIMCardAction(isSelected: boolean): ISetESIMCardAction {
  return {
    type: ActionTypes.CAMPAIGN.OVERVIEW.SET_ESIM_CARD,
    payload: isSelected,
  };
}

export function setEmailWasValidatedAction(wasValidated: boolean): ISetEmailWasValidatedAction {
  return {
    type: ActionTypes.CAMPAIGN.OVERVIEW.SET_EMAIL_WAS_VALIDATED,
    payload: wasValidated,
  };
}

export function setDeliveryOptionAction(deliveryOption: string): ISetDeliveryOptionAction {
  return {
    type: ActionTypes.CAMPAIGN.OVERVIEW.SET_DELIVERY_OPTION,
    payload: deliveryOption,
  };
}

export function setDeliveryAddressAction(addressInfo: IPakValues): ISetDeliveryAddressAction {
  return {
    type: ActionTypes.CAMPAIGN.OVERVIEW.SET_DELIVERY_ADDRESS,
    payload: addressInfo,
  };
}

export function clearDeliveryAddressAction(): IClearDeliveryAddressAction {
  return {
    type: ActionTypes.CAMPAIGN.OVERVIEW.CLEAR_DELIVERY_ADDRESS,
    payload: null,
  };
}

export function setSelectedStoreIdAction(storeId: number): ISetSelectedStoreIdAction {
  return {
    type: ActionTypes.CAMPAIGN.OVERVIEW.SET_SELECTED_STORE_ID,
    payload: storeId,
  };
}

export function submitCampaignAction(lsId: number): ISubmitCampaignAction {
  return {
    type: ActionTypes.CAMPAIGN.OVERVIEW.SUBMIT,
    payload: lsId,
  };
}

export function processCampaignSubmitAction(processData: any): IProcessCampaignSubmitAction {
  return {
    type: ActionTypes.CAMPAIGN.OVERVIEW.SUBMIT_PROCESS,
    payload: processData
  };
}


